import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Link = ({ text, href, className }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames('bs-gamblingCompliance__link', className)}
    >
        {text}
    </a>
);

Link.defaultProps = {
    className: null,
};

Link.propTypes = {
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default Link;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/components/Link.jsx